<input #file type="file" placeholder="selecione o arquivo" [accept]="type" (change)="readFile($event)" [hidden]="true">
{{label}}
<button mat-flat-button type="button" [color]="color" (click)="file.click()"><i class="fas fa-image"></i>Selecionar</button>
<span *ngIf="nomeArquivo" style="margin-left: 1em; display: inline-block">Arquivo selecionado: <strong>{{nomeArquivo}}</strong></span>
<div class="image" [style.backgroundColor]="bg" *ngIf="type == 'image/*' && targetControl.value">
  <img [src]="'data:image/png;base64,'+targetControl.value" />
</div>